import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageLoadDirective } from '@directives/image-load.directive';
import { LoaderComponent } from '@modules/shared/loader/loader.component';
import { ZoomContainerComponent } from '@modules/shared/zoom-container/zoom-container.component';
import { MediaType } from '@pixacare/domain';
import { GalleryItem } from '@shared/models/gallery-item';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'pxc-comparison-gallery-item',
  imports: [CommonModule, LoaderComponent, ZoomContainerComponent, ImageLoadDirective],
  templateUrl: './comparison-gallery-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisonGalleryItemComponent {
  @Input() item: GalleryItem;

  @Output() loadError = new EventEmitter<void>();

  private readonly _isLoaded$ = new BehaviorSubject<boolean>(false);

  readonly MediaType = MediaType;

  readonly isLoaded$ = this._isLoaded$.asObservable();

  onPictureLoad(): void {
    this._isLoaded$.next(true);
  }

  onPictureError(): void {
    this._isLoaded$.next(true);
    this.loadError.emit();
  }
}
